
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";

// Images
const exteriorImage = "/lovable-uploads/3e0a6fee-5e91-4ea9-9c5a-0f10f9627438.png";

const CTASection = () => {
  return (
    <section className="relative py-16 md:py-24 overflow-hidden">
      <div className="absolute inset-0">
        <img src={exteriorImage} alt="Rural Tasmania accommodation - exterior view of The Cottage at Flowerpot family holiday house" className="w-full h-full object-cover" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6">
        <div className="max-w-2xl">
          <motion.h2 
            className="text-3xl md:text-4xl font-bold text-white mb-6 text-shadow-sm"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            Ready to Book Your Tasmania Accommodation?
          </motion.h2>
          <motion.p 
            className="text-white/90 mb-8 text-shadow-sm"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.1 }}
          >
            Whether you're planning a multi-generational family holiday, an artist retreat, a writer's retreat, or an executive getaway, book your stay at this peaceful rural Tasmania accommodation.
          </motion.p>
          <motion.div 
            className="flex flex-col sm:flex-row gap-4"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            <Button asChild className="bg-cottage-600 hover:bg-cottage-700 text-white px-8 py-6 drop-shadow-[0_2px_3px_rgba(0,0,0,0.5)]" size="lg">
              <Link to="/contact">Contact</Link>
            </Button>
            <Button asChild className="bg-cottage-600 hover:bg-cottage-700 text-white px-8 py-6 drop-shadow-[0_2px_3px_rgba(0,0,0,0.5)]" size="lg">
              <Link to="/book">Book</Link>
            </Button>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
